/**
 * 💬 Chat Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - refresh token 자동 갱신 지원
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

// Chat API 베이스 URL - OpenAPI spec과 일치
const getChatApiBaseUrl = (): string => {
  return process.env.CHAT_API_BASE_URL || 'https://api.ugot.uk/api/chat';
};

// Chat 도메인용 커스텀 인스턴스 생성
// createOrvalCustomInstance를 사용하여 refresh token 자동 갱신 지원
export const customInstance = createOrvalCustomInstance(
  getChatApiBaseUrl(),
  {
    timeout: 30000, // 30초
    enableDebug: process.env.NODE_ENV === 'development',
    onAuthError: () => {
      console.warn('💬 Chat API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
